"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var of_1 = require("rxjs/observable/of");
exports.DATA_POINT_GROUP_IDENTITY_FIELD_NAME = "DataPointGroupID";
exports.DATA_POINT_ITEM_IDENTITY_FIELD_NAME = "DataPointItemID";
exports.DATA_POINT_ITEM_PARENT_IDENTITY_FIELD_NAME = "GroupID";
exports.DATA_POINT_GROUPS_CATEGORY_SYSTEM_NAME = "DataPointGroups";
exports.DATA_POINT_ITEMS_CATEGORY_SYSTEM_NAME = "DataPointItems";
var DPUtil = /** @class */ (function () {
    function DPUtil() {
    }
    /**
     * Method to check is DataPointGroup unique
     */
    DPUtil.dataPointClassifierUnique = function (classifiers, currentLanguageId, name) {
        var _this = this;
        return classifiers.pipe(operators_1.switchMap(function (res) { return of_1.of(_this.nameUnique(res.getData(), currentLanguageId, name)); }));
    };
    /**
     * Method to check is DataPointGroup unique by name
     * @param {Classifier[]} classifiers
     * @param {number} currentLanguageId
     * @param {string} name of selected Classifier
     * @returns {boolean}
     */
    DPUtil.nameUnique = function (classifiers, currentLanguageId, name) {
        for (var _i = 0, classifiers_1 = classifiers; _i < classifiers_1.length; _i++) {
            var classifier = classifiers_1[_i];
            if (classifier.getMultilingualName().getValue(currentLanguageId) === name)
                return false;
        }
        return true;
    };
    return DPUtil;
}());
exports.DPUtil = DPUtil;
//# sourceMappingURL=data-point.util.js.map